import React from 'react';
import { useHistory } from 'react-router';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import Modal from 'components/ui/Modal';
import { ContentSection, HereLink } from './LoyaltyMismatchModal.styles';

const LoyaltyMismatchModal = ({ isOpen = false, onClose = () => {}, onCtaClick }) => {
  const history = useHistory();
  const handleRedirectToClubEurostar = () => {
    if (onCtaClick) {
      onCtaClick();
    }
    history.push(`/clubeurostar/manage`);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ContentSection id="not-loyalty-account">
        <FormattedMessage
          id="errorBoundary.mismatchedLoyalty"
          values={{
            here: (
              <HereLink id="not-loyalty-account-here-link" onClick={handleRedirectToClubEurostar}>
                <FormattedMessage id="errorBoundary.linkHere" />
              </HereLink>
            )
          }}
        />
      </ContentSection>
    </Modal>
  );
};

LoyaltyMismatchModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onCtaClick: PropTypes.func
};

export default LoyaltyMismatchModal;
